import type { PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {StockGetterOptions} from '@Libraries/pmw-stock-media-library';

interface StateProps {
  stockGetterOptions: StockGetterOptions;
  isRecentStockAvailable: boolean;
}

const initialState: StateProps = {
  stockGetterOptions: {},
  isRecentStockAvailable: false,
};

export const stockPanelSlice = createSlice({
  name: 'stockPanel',
  initialState,
  reducers: {
    setStockGetterOptions(state, action: PayloadAction<StockGetterOptions>) {
      state.stockGetterOptions = {...action.payload};
    },
    setRecentStockAvailability(state, action: PayloadAction<boolean>) {
      if (state.isRecentStockAvailable !== action.payload) {
        state.isRecentStockAvailable = action.payload;
      }
    },
  },
});

export const {setStockGetterOptions, setRecentStockAvailability} = stockPanelSlice.actions;
export const stockReducer = stockPanelSlice.reducer;
